export const validatePasswordStrength = (password: string) => {
  if (!password) return false;
  // Check password length
  if (password.length < 8) return false;
  // Contains lowercase
  if (!/[a-z]/.test(password)) return false;
  // Contains uppercase
  if (!/[A-Z]/.test(password)) return false;
  // Contains numbers
  if (!/\d/.test(password)) return false;

  // Contains special characters
  if (!/[^A-Za-z0-9]/.test(password)) return false;
  return true;
};
